import { MutationHookOptions, MutationTuple, useMutation } from '@apollo/client'
import {
  createReferral,
  createReferralVariables,
} from '../../../../models/graphqlTypes'

import { CREATE_REFERRAL } from '../../../../operations/patientReferralOperations'

type Options = MutationHookOptions<createReferral, createReferralVariables>

type Return = MutationTuple<createReferral, createReferralVariables>

export const useReferralCreate = (options: Options = {}): Return => {
  return useMutation<createReferral, createReferralVariables>(
    CREATE_REFERRAL,
    options
  )
}
